<template>
  <div class="vx-row">
    <div class="vx-col sm:w-2/3 content-wrapper">
      <div class="flex mb-4">
        <div class="lg:w-full w-full bg-grid-color h-12">
          <vs-card class="px-5 py-5">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <!-- <vx-tooltip text="Must be between 5-12 characters" class="" position="top">
                  <span>Promo Code</span>
                  <i class="ml-2 fa fa-question-circle" aria-hidden="true"></i>
                </vx-tooltip> -->
                <span>Promo Code</span>
                <div style="font-size:0.75rem; color:#aaa;">
                  Must be between 5-12 characters
                </div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="{
                    required: true,
                    regex: '^[a-zA-Z0-9]+$',
                    min: 5,
                    max: 12
                  }"
                  name="pccode"
                  class="w-full"
                  v-model="form.pccode"
                />
                <span class="text-danger text-sm" v-show="errors.has('pccode')">
                  {{ splitError(errors.first("pccode"), "pccode") }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Promotion Title</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="promotitle"
                  class="w-full"
                  v-model="form.promotitle"
                  :maxlength="200"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('promotitle')"
                  >{{
                    splitError(errors.first("promotitle"), "promotitle")
                  }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <!-- <vx-tooltip text="Shown instead of Title where space is limited" class="" position="top">
                  <span>Short Title</span>
                  <i class="ml-2 fa fa-question-circle" aria-hidden="true"></i>
                </vx-tooltip> -->
                <span>Short Title</span>
                <div style="font-size:0.75rem; color:#aaa;">
                  Shown instead of Title where space is limited
                </div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  v-validate="'required'"
                  name="promoshortname"
                  class="w-full"
                  v-model="form.promoshortname"
                  :maxlength="200"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('promoshortname')"
                  >{{
                    splitError(errors.first("promoshortname"), "promoshortname")
                  }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Description</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  class="w-full"
                  v-model="form.promodesc"
                  :maxlength="200"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Discount</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-row mb-6">
                  <div class="vx-col">
                    <vs-input
                      v-if="form.disctype === 'percent'"
                      v-validate="{ required: true, max_value: 100 }"
                      name="discvalue"
                      v-model="form.discvalue"
                      style="width:120px;"
                      onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)"
                      onpaste="return false"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('discvalue')"
                    >
                      {{ splitError(errors.first("discvalue"), "discvalue") }}
                    </span>
                    <vs-input
                      v-if="form.disctype === 'amount'"
                      v-validate="{ required: true }"
                      name="discvalue"
                      v-model="form.discvalue"
                      style="width:120px;"
                      onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)"
                    />
                  </div>

                  <div class="vx-col sm:w-2/3">
                    <ul style="display:inline-block; padding-top:15px;">
                      <li style="display:inline-block">
                        <vs-radio
                          v-model="form.disctype"
                          vs-value="percent"
                          class="mx-3"
                          >Percent (%)</vs-radio
                        >
                      </li>
                      <li style="display:inline-block">
                        <vs-radio
                          v-model="form.disctype"
                          vs-value="amount"
                          class="mx-3"
                        >
                          {{ currency }}
                        </vs-radio>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Discount from</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul style="display:inline-block; padding-top:15px;">
                  <li style="display:inline-block">
                    <vs-radio
                      v-model="form.discfrom"
                      vs-value="fullprice"
                      class="mx-3"
                      >Full Price</vs-radio
                    >
                  </li>
                  <li style="display:inline-block">
                    <vs-radio
                      v-model="form.discfrom"
                      vs-value="currentprice"
                      class="mx-3"
                      >Current Price</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div> -->

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Period</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="form.date_start"
                  placeholder="Date Time Start"
                />
                <span class="mx-4">to</span>
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="form.date_end"
                  placeholder="Date Time End"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <!-- <vx-tooltip text="Number of times this can be used" class="" position="top">
                  <span>Quantity</span>
                  <i class="ml-2 fa fa-question-circle" aria-hidden="true"></i>
                </vx-tooltip> -->
                <span>Quantity</span>
                <div style="font-size:0.75rem; color:#aaa;">
                  Number of times this can be used
                </div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-row mb-6 vx-align-center">
                  <div
                    class="vx-col"
                    style="display:inline-block; padding-top:15px;"
                  >
                    <vs-radio
                      v-model="isPromoLimited"
                      vs-name="quantity"
                      :vs-value="false"
                      >Unlimited</vs-radio
                    >
                  </div>
                  <div
                    class="vx-col"
                    style="display:inline-block; padding-top:15px;"
                  >
                    <vs-radio
                      v-model="isPromoLimited"
                      vs-name="quantity"
                      :vs-value="true"
                      >Limit usage</vs-radio
                    >
                  </div>
                  <div class="vx-col">
                    <vs-input
                      v-validate="{
                        required: isPromoLimited,
                        min_value: 1
                      }"
                      v-on:blur="validateQuantity()"
                      name="qty"
                      id="qty"
                      ref="qty"
                      class="w-full"
                      v-model="form.qty"
                      :disabled="!isPromoLimited"
                      onkeypress="return /^[0-9]/i.test(event.key)"
                      onpaste="return false"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('qty')"
                    >
                      {{ splitError(errors.first("qty"), "qty") }}
                    </span>
                  </div>
                  <div
                    class="vx-col"
                    style="display:inline-block; padding-top:15px;"
                  >
                    times
                  </div>
                </div>
              </div>
            </div>
            <section>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Discount On</span>
                  <div style="font-size:0.75rem; color:#aaa;"></div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio
                        vs-name="radios-disclevel"
                        v-model="form.disclevel"
                        :vs-value="1"
                        >All</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio
                        vs-name="radios-disclevel"
                        v-model="form.disclevel"
                        :vs-value="2"
                        >Selective Tickets</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div v-if="form.disclevel == 2" class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  Select the tickets the discount is applicable to
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="centerx">
                    <li
                      v-for="(item, i) in productList"
                      :key="i"
                      style="margin:12px 0;"
                    >
                      <vs-checkbox v-model="item.selected">
                        <div>{{ item.pro_name }}</div>
                        <div style="font-size: 0.75rem; color:#aaa;">
                          {{ item.pro_shortdesc }}
                        </div>
                      </vs-checkbox>
                    </li>
                  </ul>

                  <vs-button
                    v-if="!hideSeemore && totalTicket > 10"
                    type="flat"
                    class="mr-3 mb-2 p-1"
                    @click="seeAllTicket"
                  >
                    See more
                  </vs-button>
                </div>
              </div>
            </section>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <!-- <vx-tooltip text="Internal use" class="" position="top">
                  <span>Note attached to order (Internal use)</span>
                  <i class="ml-2 fa fa-question-circle" aria-hidden="true"></i>
                </vx-tooltip> -->
                <span>Note attached to order (Internal use)</span>
                <div style="font-size:0.75rem; color:#aaa;">Internal use</div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea class="w-full" v-model="form.promonote" />
                <!-- <span
                  class="text-danger text-sm"
                  v-show="errors.has('promonote')"
                  >{{ splitError(errors.first("promonote"), 'promonote') }}</span
                > -->
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Status</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="radios-promo_status"
                      v-model="form.promo_status"
                      :vs-value="1"
                      >Enabled</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="radios-promo_status"
                      v-model="form.promo_status"
                      :vs-value="0"
                      >Disabled</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Weight</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="{}"
                  name="weight"
                  class="w-full"
                  v-model="form.weight"
                  onkeypress="return /^[0-9]/i.test(event.key)"
                  onpaste="return false"
                />
                <span class="text-danger text-sm" v-show="errors.has('weight')">
                  {{ splitError(errors.first("weight"), "weight") }}
                </span>
              </div>
            </div>

            <div style="height:30px;"></div>
            <div class="vx-row pt-2 mt-0">
              <div class="vx-col w-full ml-auto">
                <vs-button class="mr-3 mb-2" @click="validateForm"
                  >Save
                </vs-button>

                <vs-button class="mr-3 mb-2" type="border" @click="cancel()"
                  >Cancel
                </vs-button>
              </div>
            </div>
          </vs-card>
        </div>
      </div>
    </div>
    <div class="vx-col sm:w-1/3 pl-4 content-wrapper">
      <div class="con-vs-card px-5 py-5">
        <div style="display:flex;justify-content:space-between;">
          <div>
            <div>0 used</div>
          </div>
          <div>
            <div v-if="isPromoLimited">{{ parseInt(form.qty) || "" }}</div>
            <div v-else>Unlimited</div>
          </div>
        </div>

        <div>
          <vs-progress :percent="0" color="primary"></vs-progress>
        </div>
        <div
          v-if="isPromoLimited && !isNaN(parseInt(form.qty))"
          style="font-size: 0.75rem; color: #626262"
        >
          {{ parseInt(form.qty) }} remaining
        </div>
      </div>
      <div class="con-vs-card mt-5 px-5 py-5">
        <div>
          <div>
            <div style="font-size: 0.75rem; color: #626262">Preview</div>
          </div>
          <div style="font-size: 1.25rem; color: #000" class="mt-2">
            Use code
          </div>
          <div style="font-size: 2rem; color: #000">
            {{ form.pccode }}
          </div>
          <div>
            {{ form.promotitle }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";

import Service from "@/services";
import { timezones } from "@/utils/Timezones";

import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    VxAutoSuggest,
    flatPickr
  },
  props: ["promocode_id"],
  computed: {
    ...mapState({
      accessToken: state => {
        return state.Auth.accessToken;
      },
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  data() {
    return {
      productList: [],
      isPromoLimited: false,
      form: {
        e: null,
        promo_type: "code",
        promotitle: null,
        promoshortname: null,
        promodesc: null,
        disctype: "percent",
        discvalue: null,
        // discfrom: "fullprice",
        disclevel: 1,
        date_start: null,
        date_end: null,
        pccode: null,
        promonote: null,
        promo_status: 1,
        selective: []
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i"
      },
      currency: "THB",
      per_page: 10,
      totalTicket: 0,
      hideSeemore: false
    };
  },
  watch: {
    "form.pccode": function(newVal, oldVal) {
      this.form.pccode = newVal.toUpperCase();
    },
    isPromoLimited: function() {
      if (!this.isPromoLimited) {
        // this.form.qty = ''
      } else {
        setTimeout(() => {
          document.getElementById("qty").focus();
        }, 300);
      }
    }
  },
  created() {
    this.form.e = this.e;
    this.getcurrency();

    let data = {
      e: this.e
    };

    let params = Object.keys(data)
      .map(key => key + "=" + data[key])
      .join("&");

    const paramsData = params + `&perPage=${this.per_page}`;

    Service.Product.gets(paramsData).then(res => {
      this.totalTicket = res.data.total;
      if (res.data.total > this.per_page) {
        this.hideSeemore = false;
      } else {
        this.hideSeemore = true;
      }
      this.productList = res.data.rows.map(item => {
        return {
          product_id: item.product_id,
          pro_name: item.pro_name,
          pro_shortdesc: item.pro_shortdesc,
          selected: false
        };
      });
    });
  },
  methods: {
    validateQuantity() {
      /* free event, max = 100 */
      this.$validator.validate("qty").then(result => {
        console.log("result", result);
        if (result) {
          // if form have no errors
          // this.submit();
        }
      });
      return;
    },
    splitError(val, word) {
      if (!val) {
        return;
      } else {
        const data = val.split(word);
        return data[0] + data[1];
      }
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          if (!this.isPromoLimited) {
            this.form.qty = "";
          }
          this.submit();
        }
      });
    },
    cancel() {
      this.$router.push("/promocodes?s=" + this.s + "&e=" + this.e);
    },
    getcurrency() {
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s
      };
      Service.Event.get(data.e)
        .then(res => {
          this.currency = res.data.event.currency;
        })
        .catch(() => {});
    },
    submit() {
      this.form.e = this.e;
      this.form.selective = this.productList.filter(x => x.selected == true);

      this.$vs.loading();
      this.qty = this.isPromoLimited ? this.qty : null;

      Service.Bootsale.addPromo(this.form)
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Add new promocode completed.",
              color: "success"
            });
            this.$router.push("/promocodes?s=" + this.s + "&e=" + this.e);
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          const errorkeys = Object.keys(error);
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + error[errorkeys[0]][0],
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    seeAllTicket() {
      let data = {
        e: this.e
      };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      const selectedid = this.productList
        .filter(item => item.selected)
        .map(item => item.product_id);
      const paramsData = params + `&perPage=${this.totalTicket}`;
      Service.Product.gets(paramsData).then(res => {
        this.productList = res.data.rows.map(item => {
          return { ...item, selected: selectedid.includes(item.product_id) };
        });
        this.hideSeemore = true;
      });
    }
  }
};
</script>
